<template>
<div class="left-content">
  <p class="title">{{ detailData.title }}</p>
  <p class="type">{{ detailData.type }}</p>
  <img class="bg-img" :src="detailData.image || '/static/specialCompetitiom/speCombj.png'"/>
  <div class="special-content">
    <p v-for="(paragraph, index) in introduction" :key="index">{{ paragraph }}</p>
    <p class="contact">{{$t('global.联系')}}：<span>{{ detailData.email }}</span> </p>
  </div>
</div>
</template>

<script>
export default {
    data() {
    return {
      detailData: {}
    };
  },

  computed: {
    introduction: function() {
      if(!this.detailData.introduction) return ''
      return this.detailData.introduction.split('\n')
    }
  },

  watch: {
    $route: function() {
      let currentID = this.$route.params.id;
      if (currentID == this.detailData.id) return;
      this.getData(this.$route.params.id)
    }
  },

  methods: {
    getData(activityId) {
      this.$http
        .get("/api/activity/detail", {
          params: {
            activityId: activityId
          }
        })
        .then(data => {
          let d = data.data;
          let detailData = {};
          detailData.id = d.id;
          detailData.title = d.organizeName;
          detailData.type = d.professionTitle;
          detailData.image = d.organizeThumb;
          detailData.introduction = d.organizeInfo;
          detailData.email = d.organizeEmail
          this.detailData = detailData;
        });
    }
  },

  created() {
    this.getData(this.$route.params.id)
  }
};
</script>

<style lang="stylus" scoped>
.left-content {
  width: 10.8rem;
  margin-top: 0.2rem;
  padding: 0.4rem 0.6rem;
  background-color: #ffffff;

  .title {
    color: #333333;
    font-size: 0.39rem;
    font-weight: bold;
  }

  .type {
    color: #777777;
    font-size: 0.18rem;
    margin-top: 0.12rem;
  }

  .bg-img {
    margin-top: 0.39rem;
    width: 10.8rem;
    height: 6.12rem;
    background: url('/static/specialCompetitiom/speCombj.png') no-repeat;
    background-size: cover;
  }

  .special-content {
    color: #333333;
    font-size: 0.16rem;

    p {
      margin-top: 0.36rem;
    }

    .contact {
      font-size: 0.18rem;
      color: #777777;
      margin-top: 0.53rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/match/About.vue